import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import React from "react"

interface Props {
  alt?: string
  filename: string
  className?: string
  style?: React.CSSProperties
}

const Image = ({ alt, filename, className, style }: Props) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile(filter: { dir: { regex: "/^((?!posts).)*$/" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 750, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }
  `)

  const image = data.images.edges.find(n => n.node.relativePath.includes(filename))
  if (!image) {
    return null
  }

  return (
    <Img
      alt={alt}
      fluid={image.node.childImageSharp.fluid}
      className={className}
      style={style}
    />
  )
}

export default Image
